import './FileUploader.scss';
import { UppyFile } from '@uppy/core';

export enum UploaderState {
    INIT,
    EMPTY,
    FILES_ADDED,
    UPLOADING,
    DONE,
}

const btnTextForState = {
    [UploaderState.INIT]: kuura.getMessage('js_files.upload_btn'),
    [UploaderState.EMPTY]: kuura.getMessage('js_files.upload_btn'),
    [UploaderState.FILES_ADDED]: kuura.getMessage('js_files.upload_btn'),
    [UploaderState.UPLOADING]: kuura.getMessage('js_files.upload_btn'),
    [UploaderState.DONE]: kuura.getMessage('general.close'),
};

const modelTypes = {
    model: ['dxf', 'dwg', 'lin', 'gt', 'prf', 'xml', 'ini', 'nfcl', 'kof', 'txt', 'jfcl'],
    archive: ['zip'],
    trimble: ['cfg', 'svd', 'svl', 'csv'],
    topcon: ['tp3', 'tn3', 'rd3', 'ln3', 'pt3'],
    leica: ['pxy', 'trm', 'lmd', 'l3d', 'geo', 'csv'],

    all() {
        return _.flatten(Object.values(this).filter(Array.isArray), true);
    },
};

function isModel(filename: string) {
    return modelTypes.all().includes(utils.getExtensionFromFilename(filename).toLowerCase());
}

function isZip(filename: string) {
    return modelTypes.archive.includes(utils.getExtensionFromFilename(filename).toLowerCase());
}

function printUppyStatusForFile(file: UppyFile, msg: string, color = 'black') {
    const el = document.querySelector(`.uppy-Dashboard-Item-name[title="${file.name}"]`)?.parentNode?.parentNode;
    $(el).find('.uppy-Dashboard-Item-status').html(`<span style="color: ${color}">${msg}</span>`);
}

export const MAX_UPLOAD_FILES = 100;

export const FileUploader = {
    isModel,
    isZip,
    btnTextForState,
    printUppyStatusForFile,
};
